import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { positionDefault, positionRight } from '../Popover/usePopover.js';
import { DropdownContent } from '../Dropdown/DropdownContent.js';
import { useMenuDropdownContext } from '../Menu/MenuContext/MenuProvider.js';
import { Card } from '../Card/Card.js';
import { DatePicker } from '../DatePicker/DatePicker/DatePicker.js';

var DatePickerMenuContent = function (_a) {
    var align = _a.align, portal = _a.portal, cardProp = _a.cardProp, dropdownContentProp = _a.dropdownContentProp, onSelect = _a.onSelect, _b = _a.autoFocus, autoFocus = _b === void 0 ? true : _b, props = __rest(_a, ["align", "portal", "cardProp", "dropdownContentProp", "onSelect", "autoFocus"]);
    var context = useMenuDropdownContext();
    var id = context.id, isOpen = context.isOpen;
    var dropdownContentProps = __assign(__assign(__assign({ id: "".concat(id, "-dropdown"), portal: portal, role: "menu", autoFocus: autoFocus, "aria-labelledby": "".concat(id) }, (align === "left" && { position: positionDefault })), (align === "right" && { position: positionRight })), dropdownContentProp);
    return (jsx(DropdownContent, __assign({ themeKey: "datePickerMenuContent" }, dropdownContentProps, { children: jsx(Card, __assign({ elevation: "4", themeKey: "datePickerMenuContentCard" }, cardProp, { children: isOpen && (jsx(DatePicker, __assign({ onSelect: function (date) {
                    onSelect && onSelect(__assign(__assign({}, context), { date: date }));
                }, autoFocus: autoFocus }, props))) })) })));
};

export { DatePickerMenuContent };
//# sourceMappingURL=DatePickerMenuContent.js.map
